var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getCards)?_c('div',{attrs:{"data-component":"trick"}},_vm._l((_vm.getCards),function(card,index){return _c('card',{key:index,attrs:{"card":card,"index":index,"data-winner":_vm.getCardIsWinningCardInCurrentTrick(card)}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }